import React from "react";
import Footer from "../../partials/Footers";
import Header from "../../partials/Headers";
import BannerSection from "./BannerSection";

export default function Layouts({ background, children, pageTitle, breadcrumbs = [], banner=true }) {
  return (
    <>
      <Header />
      {banner && <BannerSection background={background} pageTitle={pageTitle} breadcrumbs={breadcrumbs} />}
      {children && children}
      <Footer />
    </>
  );
}
